import { FC, useContext, useState } from "react";
import NotificationDispatch, { showErrorNotification } from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useLeasingCompaniesApi } from "../../http/leasingCompanies/api";
import ModalDialog from "../ui/ModalDialog";

type DeleteLeasingCompanyDialogProps = {
  leasingCompanyId: string;
  onClose: () => void;
};

const DeleteLeasingCompanyDialog: FC<DeleteLeasingCompanyDialogProps> = ({ leasingCompanyId, onClose }) => {
  const i18n = useI18n();
  const leasingCompaniesApi = useLeasingCompaniesApi();
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <ModalDialog
      onClose={onClose}
      title={i18n.t.leasingCompanies.delete}
      isSubmitting={isSubmitting}
      actions={[
        {
          title: i18n.t.common.cancel,
          type: "secondary",
          onClick: onClose,
        },
        {
          title: i18n.t.common.yes,

          onClick: () => {
            setIsSubmitting(true);
            leasingCompaniesApi
              .deleteAdminLeasingCompany(leasingCompanyId)
              .then(onClose)
              .catch((err) => dispatch(showErrorNotification(i18n, err)))
              .finally(() => setIsSubmitting(false));
          },
        },
      ]}
    >
      {i18n.t.leasingCompanies.questions.delete}
    </ModalDialog>
  );
};

export default DeleteLeasingCompanyDialog;
